module.exports = __webpack_public_path__ + "static/how-it-works-4-fc541920f31a6d0e23a346de82b78cd5.svg";